import React from "react";
import { Loading } from "@ss/mtd-react3";
import "./style.scss";
import EllipsisTooltip from "@/components/tooltip/ellipsis-tooltip";
import noContent from "@/assets/images/no-content.png";
import { fetchData } from "@/utils";

class CardList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: false, // 添加页面初始加载状态
            assetsList: [],
            page: 1,
            pageSize: 23,
            hasMore: true,
            isLoadingMore: false // 是否正在加载更多
        };
    }
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        // 组件挂载时，从路由参数获取 type
        try {
            this.getAssetsData();
        } catch (error) {
            console.error("获取数据失败:", error);
            this.setState({
                assetsList: [],
                pageLoading: false
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    // 处理滚动事件
    handleScroll = () => {
        // 如果正在加载或没有更多数据，直接返回
        if (this.state.isLoadingMore || !this.state.hasMore) return;

        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = document.documentElement.scrollTop;
        const clientHeight = document.documentElement.clientHeight;

        // 当距离底部100px时触发加载更多
        if (scrollHeight - scrollTop - clientHeight < 100) {
            this.loadMore();
        }
    };
    // 加载更多
    loadMore = () => {
        this.setState(
            prevState => ({
                pageSize: prevState.pageSize + 6, // 页码加10
                isLoadingMore: true
            }),
            () => this.getAssetsData(true)
        );
    };
    // 获取assets列表数据
    getAssetsData = async (isLoadMore = false) => {
        const { pageSize, page } = this.state;
        const { url, keyword, assetSortCol, activeNav } = this.props;
        try {
            if (!isLoadMore) {
                this.setState({ pageLoading: true });
            }
            // 调用接口获取数据
            const params = {
                page: page,
                pageSize: pageSize,
                keyword,
                directoryId: activeNav === "all" ? null : Number(activeNav),
                sortCol: assetSortCol
            };
            const response = await fetchData(url, params);
            // 更新状态
            this.setState({
                assetsList: response.materialList || [],
                pageLoading: false,
                isLoadingMore: false,

                hasMore: (response.materialList || []).length === pageSize
            });
        } catch (error) {
            console.error("获取数据失败:", error);
            this.setState({
                assetsList: [],
                pageLoading: false,
                isLoadingMore: false,
                hasMore: false
            });
        }
    };
    // 添加重置分页的方法
    resetPagination = () => {
        this.setState(
            {
                page: 1,
                pageSize: 6,
                hasMore: true,
                isLoadingMore: false
            },
            this.getAssetsData
        );
    };
    // 跳转详情页
    handleToAssetDetail = materialCode => {
        // this.props.history.push(`/AssetDetail?materialCode=${materialCode}`);
        const { sourceType } = this.props;
        const isInner = window.location.href.indexOf("assets-internal") > -1;
        window.open(
            `${
                isInner ? "/assets-internal" : "/assets"
            }/${sourceType}?materialCode=${materialCode}`,
            "_blank"
        );
    };
    render() {
        const { pageLoading, assetsList, isLoadingMore } = this.state;
        return (
            <div>
                {pageLoading ? (
                    <div className="brand-content-page loading-container">
                        <Loading direction="vertical" message="Loading..." />
                    </div>
                ) : assetsList?.length > 0 ? (
                    <div>
                        <div className="card-grid-brandAggregation">
                            {assetsList.map((card, index) => (
                                <div
                                    key={card.materialId}
                                    className="card-brandAggregation"
                                    style={{
                                        height: "273.37px"
                                    }}
                                >
                                    <div
                                        className="card-img-div-brandAggregation"
                                        onClick={() =>
                                            this.handleToAssetDetail(
                                                card.materialCode
                                            )
                                        }
                                    >
                                        <img
                                            src={(() => {
                                                try {
                                                    return JSON.parse(
                                                        card.materialImgUrl
                                                    )[0].fileUrl;
                                                } catch (e) {
                                                    console.error(
                                                        "解析图片URL失败:",
                                                        e
                                                    );
                                                    return ""; // 或者返回一个默认图片URL
                                                }
                                            })()}
                                            alt=""
                                            className="card-img-item-assets" // 添加不同的类名以便样式控制
                                        />
                                    </div>
                                    <div className="card-info">
                                        <EllipsisTooltip
                                            content={card.materialName}
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 600,
                                                margin: 0
                                            }}
                                            compareWidth={380}
                                        >
                                            {card.materialName}
                                        </EllipsisTooltip>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* 加载更多的loading状态 */}
                        {isLoadingMore && (
                            <div className="loading">
                                <Loading
                                    direction={"vertical"}
                                    message={"Loading more..."}
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        <img className="empty-state" src={noContent} alt="" />
                    </div>
                )}
            </div>
        );
    }
}

export default CardList;
